import { behindScenes } from "@/mocks/homeData";
import SectionHeading from "@/components/base/SectionHeading";

export default function BehindScenes() {
  return (
    <section id="scenes" className="scroll-mt-24 bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="Behind The Scenes"
          title="拍摄花絮"
          desc="一组好看的写真背后，是灯光、时间与调色的反复调整。这里记录几个拍摄现场的真实细节。"
        />

        <div className="mt-10 space-y-8">
          {behindScenes.map((scene, index) => {
            const reversed = index % 2 === 1;
            return (
              <article
                key={scene.id}
                className={`flex flex-col gap-6 lg:flex-row lg:items-center ${
                  reversed ? "lg:flex-row-reverse" : ""
                }`}
              >
                <div className="w-full overflow-hidden rounded-lg border border-background-200 lg:w-1/2">
                  <div className="relative aspect-[16/10] w-full">
                    <img
                      src={scene.image}
                      alt={`${scene.title} 拍摄现场`}
                      title={`${scene.title} · 写真拍摄花絮`}
                      className="h-full w-full object-cover object-center"
                    />
                  </div>
                </div>
                <div className="w-full lg:w-1/2">
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line" />
                      {scene.date}
                    </span>
                    <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-accent-900">
                      花絮记录
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
                    {scene.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                    {scene.desc}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}